import { AxiosResponse } from 'axios';
import { getRequest } from '../../../utils/apiUtils';

export const getDashboardData = ():Promise<AxiosResponse<
CapBayApiData<dashboard.DashboardData>
>> => (
  getRequest('/p2p-admin/dashboard')
);
